export * from './list-main-page/list-main-page.component';
export * from './header-main-page/header-main-page.component';
